import { t } from '@sm/intl';
import { Packages } from '~shared/constants/pricing';

import COPY from './copy';
import { PackageDef, PER_MONTH_ANNUALLY } from './types';

const PER_MONTH = t(COPY.PER_MONTH);
const PER_USER_PER_MONTH = t(COPY.PER_USER_PER_MONTH);
const BILLED_ANNUALLY = t(COPY.BILLED_ANNUALLY);

const getPerMonthAnnually: PER_MONTH_ANNUALLY = price => t(COPY.PER_MONTH_ANNUALLY, { price });
const BR_BILLED_ANNUALLY = t(COPY.BR_BILLED_ANNUALLY);

const PackageDefs: PackageDef = {
  [Packages.Basic]: {
    byline: t(COPY.ALWAYS_FREE),
  },
  [Packages.TeamAdvantage]: {
    priceUnit: PER_USER_PER_MONTH,
    byline: BILLED_ANNUALLY,
  },
  [Packages.TeamPremier]: {
    priceUnit: PER_USER_PER_MONTH,
    byline: BILLED_ANNUALLY,
  },
  [`${Packages.TeamAdvantage}_BR`]: {
    byline: BR_BILLED_ANNUALLY,
  },
  [`${Packages.TeamPremier}_BR`]: {
    byline: BR_BILLED_ANNUALLY,
  },
  [Packages.Enterprise]: {
    byline: t(COPY.ENTERPRISE),
  },
  [Packages.PremierAnnual]: {
    priceUnit: PER_MONTH,
    pricePerMonthAnnually: (price: string) => getPerMonthAnnually(price),
  },
  [Packages.AdvantageAnnual]: {
    priceUnit: PER_MONTH,
    pricePerMonthAnnually: (price: string) => getPerMonthAnnually(price),
    highlighted: true,
  },
  [Packages.StandardMonthly]: {
    priceUnit: PER_MONTH,
    pricePerMonthAnnually: () => null,
  },
};

export default PackageDefs;
